<template>
  <v-skeleton-loader
    :type="type"
    :width="width"
    :height="height"
    :loading="true"
    class="mt-2"
  >
    <slot />
  </v-skeleton-loader>
</template>

<script setup lang="ts">
  defineProps<{
    type?: string | string[];
    width?: string;
    height?: string;
  }>();
</script>

<style scoped lang="sass"></style>
